/* The approved twelve-product opening. Loaded in the head to cover the first paint.
   Plays once per tab; ?intro=1 replays it for review. No prototype UI or counter. */
(() => {
  'use strict';
  const root=document.documentElement, reduce=matchMedia('(prefers-reduced-motion: reduce)');
  const KEY='alda-opener-seen', VERSION='product-circle-v1';
  const query=new URLSearchParams(location.search);
  let seen=false;try{seen=sessionStorage.getItem(KEY)===VERSION;}catch{}
  if(window.self!==window.top||query.has('preloader-preview')||reduce.matches||
     (!query.has('intro')&&(seen||location.hash||performance.getEntriesByType('navigation')[0]?.type==='back_forward')))return;

  const PRODUCTS=[['ceramic-pan',0,1.04],['silicone-turner',38,.92],['drying-mat',0,.83],
    ['steel-skimmer',38,.94],['pressure-cooker',0,1],['silicone-spatula',40,.91],
    ['acacia-board',-59,.96],['steel-strainer',38,.94],['tri-ply-kadai',0,1],
    ['wooden-ladle',-44,.95],['ceramic-tawa',0,1.04],['silicone-spoon',38,.92]];
  // the logo comes in as the last products settle and the curtain lifts sooner and quicker (the owner, 2026-10-26:
  // "slightly shorten the pre-loader timing, specially when the alda logo appears and the curtain goes up"):
  // 7.15 s -> 5.75 s; the products' arrival is unchanged
  const TIMES={start:.24,stagger:.205,entrance:1.18,logo:3.3,lift:4.55,end:5.75};
  // the whole opening plays a quarter faster, the same choreography (the owner, 2026-11-05: "make the pre-loader a
  // little faster"): 5.75 s -> 4.6 s. TIMES stay in the timeline's own time, so a rebuild on resize lines up.
  const SPEED=1.25;
  let done=false, timeline=null, loader=null, composition=null, circle=null, brand=null, main=null;
  let resizeObserver=null, resizeFrame=0, bodyInert, mainTransform='', resumeOnVisible=false;
  root.classList.add('pc-pre','pc-active');root.classList.remove('ld-landed');
  // A missing asset/runtime must never leave the shop covered or locked.
  let watchdog=setTimeout(finish,12000);
  const nodes=PRODUCTS.map(([id,angle,size])=>{
    const el=document.createElement('div');el.className='pc-product';
    const image=new Image();image.src='https://static.aldaindia.com/alda-assets/opener-circle/'+id+'.webp';image.alt='';image.decoding='async';
    el.append(image);return {el,image,angle,size};
  });
  const logo=new Image();logo.src='https://static.aldaindia.com/alda-assets/alda-logo.svg';logo.alt='';
  const imagesReady=Promise.all([...nodes.map(p=>p.image.decode()),logo.decode()]);
  // Attach the rejection handler now, while the document may still be parsing.
  const ready=imagesReady.then(()=>true,()=>false);

  function finish(){
    if(done)return;done=true;
    removeEventListener('wheel',blockScroll,{passive:false});removeEventListener('touchmove',blockScroll,{passive:false});
    clearTimeout(watchdog);cancelAnimationFrame(resizeFrame);timeline?.kill();resizeObserver?.disconnect();
    loader?.remove();
    if(main)main.style.transform=mainTransform;
    if(document.body&&bodyInert!==undefined)document.body.inert=bodyInert;
    root.classList.remove('pc-pre','pc-active','pc-revealing');root.classList.add('ld-landed');
    window.aldaLenis?.start();
    try{sessionStorage.setItem(KEY,VERSION);}catch{}
    document.dispatchEvent(new CustomEvent('alda:landed'));
  }
  function reveal(){
    root.classList.add('pc-revealing');
    document.dispatchEvent(new CustomEvent('alda:intro-reveal'));
  }
  function build(){
    timeline?.kill();
    const radius=composition.clientWidth*.365;
    gsap.set(loader,{yPercent:0});gsap.set(main,{y:24});gsap.set(brand,{opacity:0,y:9,scale:.985});
    gsap.set(circle,{rotation:-18});
    timeline=gsap.timeline({paused:true,onComplete:finish}).timeScale(SPEED);
    nodes.forEach((product,i)=>{
      const theta=-90+i*360/nodes.length, radians=theta*Math.PI/180;
      const x=Math.cos(radians)*radius,y=Math.sin(radians)*radius, rotation=theta-product.angle;
      timeline.fromTo(product.el,{x:x*1.10,y:y*1.10,rotation:rotation-5,scale:product.size*.9,opacity:0},
        {x,y,rotation,scale:product.size,opacity:1,duration:TIMES.entrance,ease:'power2.out',immediateRender:true},TIMES.start+i*TIMES.stagger);
    });
    timeline.to(circle,{rotation:0,duration:3.65,ease:'sine.out'},0);
    timeline.to(brand,{opacity:1,y:0,scale:1,duration:.75,ease:'power2.out'},TIMES.logo);
    timeline.call(reveal,null,TIMES.lift);
    timeline.to(loader,{yPercent:-102,duration:1.1,ease:'sine.inOut'},TIMES.lift);
    timeline.to(main,{y:0,duration:1.2,ease:'sine.inOut'},TIMES.lift);
  }
  async function boot(){
    if(done)return;
    if(typeof gsap==='undefined'){finish();return;}
    bodyInert=document.body.inert;document.body.inert=true;
    window.aldaLenis?.stop();
    main=document.querySelector('main');mainTransform=main?.style.transform||'';
    if(!main){finish();return;}
    loader=document.createElement('div');loader.className='alda-product-preloader';loader.setAttribute('aria-hidden','true');
    composition=document.createElement('div');composition.className='pc-composition';
    circle=document.createElement('div');circle.className='pc-circle';
    nodes.forEach(p=>circle.append(p.el));
    brand=document.createElement('div');brand.className='pc-brand';brand.append(logo);
    composition.append(circle,brand);loader.append(composition);document.body.append(loader);
    root.classList.remove('pc-pre');
    if(!await ready){finish();return;}
    if(done)return;
    clearTimeout(watchdog);
    build();
    let measuredWidth=composition.clientWidth;
    resizeObserver=new ResizeObserver(()=>{
      if(done||resizeFrame||composition.clientWidth===measuredWidth)return;
      resizeFrame=requestAnimationFrame(()=>{
        resizeFrame=0;if(done)return;
        measuredWidth=composition.clientWidth;
        const time=timeline.time(),paused=timeline.paused();
        build();timeline.pause(time);
        if(time>=TIMES.lift)reveal();
        if(!paused&&!document.hidden)timeline.play();
      });
    });
    resizeObserver.observe(composition);
    if(document.hidden)resumeOnVisible=true;else timeline.play(0);
  }
  function blockScroll(event){if(!done)event.preventDefault();}
  addEventListener('wheel',blockScroll,{passive:false});addEventListener('touchmove',blockScroll,{passive:false});
  document.addEventListener('keydown',event=>{
    if(done)return;
    if(event.key==='Escape'){event.preventDefault();finish();}
    else if(['Tab',' ','PageDown','PageUp','Home','End','ArrowDown','ArrowUp'].includes(event.key))event.preventDefault();
  },true);
  document.addEventListener('visibilitychange',()=>{
    if(done||!timeline)return;
    if(document.hidden){resumeOnVisible=!timeline.paused();timeline.pause();}
    else if(resumeOnVisible){resumeOnVisible=false;timeline.play();}
  });
  reduce.addEventListener('change',()=>{if(reduce.matches)finish();});
  addEventListener('pagehide',finish,{once:true});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot().catch(finish),{once:true});
  else boot().catch(finish);
})();
